<template>
<div>
    <el-dialog
        :visible="visible"
        :title="title"
        @close="close"
    >
        <div class="container">
            <div class="tips">请确保您本次提现的收款平台支持您要提出的币种和您提币使用的网络。如果您还不能确定，建议您先和收币平台确认后再提币。</div>
            <el-alert
                title="系统已自动过滤掉不匹配的转账忘了。选择转账网络。"
                type="success"
                :closable="false"
                show-icon>
            </el-alert>
            <div class="list">
                <div class="item">
                    <div class="item-meta">
                        <div class="meta-title">
                            <span class="text">TRX</span>
                            <span class="tag tag-default">不匹配</span>
                        </div>
                        <div class="meta-val">
                            <span>预计到账时间</span> <span class="b">≈</span> <span class="b">0分钟</span>
                        </div>
                    </div>
                    <div class="item-meta">
                        <div class="meta-title">
                            <span class="text">Tron (TRC20)</span>
                        </div>
                        <div class="meta-val">
                            <span class="b">手续费</span> <span>1 TRX</span> <span>(≈ $0.09314)</span>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="item-meta">
                        <div class="meta-title">
                            <span class="text">TRX</span>
                            <span class="tag tag-default">不匹配</span>
                        </div>
                        <div class="meta-val">
                            <span>预计到账时间</span> <span class="b">≈</span> <span class="b">0分钟</span>
                        </div>
                    </div>
                    <div class="item-meta">
                        <div class="meta-title">
                            <span class="text">Tron (TRC20)</span>
                        </div>
                        <div class="meta-val">
                            <span class="b">手续费</span> <span>1 TRX</span> <span>(≈ $0.09314)</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="extra">
                <a class="link">费用说明</a>
            </div>
        </div>
    </el-dialog>
</div>
</template>
<script>
export default {
    name:'selectNetworkDialog',
    data(){
        return {
            title:'选择网络',
            visible:false,
        }
    },
    methods:{
        open(){
            this.visible = true;
        },
        close(){
            this.visible = false;
        }
    }
}
</script>
<style lang="less" scoped>
.container {
    margin-top:-20px;
    .tips {
        padding:0 0 10px; color:#666;
    }
    .list {
        padding:10px 0 20px;
        .item {
            padding:8px 0; border-bottom:#e6e6e6 1px solid;
            .item-meta {
                display:flex; justify-content: space-between; align-items: center; color:#999; padding:3px 0;
                .meta-title {
                    .text {
                        margin-right:6px;
                    }
                    .tag {
                        line-height:1; padding:3px 8px; border-radius:4px; font-size:12px;
                        &.tag-default {
                            background:#f4f5f6; color:#999;
                        }
                    }
                }
                .meta-val {
                    .b {font-weight:700; color:#666;}
                }
            }
        }
    }
    .extra {
        padding:20px 0 0; text-align:right;
        .link {
            text-decoration: underline; cursor: pointer;
            &:hover {
                color:#4458fe;
            }
        }
    }
}
</style>